import { Component, Inject, Input, NgZone, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ResizeEvent } from "angular-resizable-element";
import { ToastrService } from "ngx-toastr";
import { Law } from "../../../models/laws";
import { LawControllerService } from "../../../services/laws-controller/law-controller.service";
import { MessageControllerService } from "../../../services/message-controller/message-controller.service";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";
import { ModalService } from "../../utils/base_modal.component";
import { BaseError } from "../base-error";

@Component({
  selector: "laws-table",
  templateUrl: "./laws-table.component.html",
  providers: [MessageControllerService, ModalService],
  styleUrls: ["./laws-table.component.scss"],
})
export class LawsTableComponent extends BaseError implements OnInit {
  @Input() public hideList: boolean = false;
  public laws: Law[] = [];
  public serviceId: string;
  // Search variables
  public searchValue: string = "";
  public searchTextFilterObject: any = {};
  // Add/Edit variables
  public showEdit: boolean = false;
  public showAdd: boolean = false;
  public law: Law;
  public style: object = {};

  constructor(private route: ActivatedRoute,
              private router: Router,
              protected serviceController: ServiceControllerService,
              @Inject(NgZone) protected zone: NgZone,
              private lawControllerService: LawControllerService, toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getSystemLaws();
  }

  public delete(law) {
    this.lawControllerService.deleteLaw(law.id).subscribe(
      (data) => {
        this.responseSuccessful("Law deleted!");
        this.ngOnInit();
        this.router.navigate(["/services/" + this.serviceId + "/lawstable"]);
      },
      (error) => this.showErrorMessageWithTitle("Law delete error!", error),
    );
  }

  public getSystemLaws() {
    this.lawControllerService.getLawsList().subscribe(
      (data) => {
        this.laws = data;
      },
      (error) => this.showErrorMessageWithTitle("Unable to get laws list", error),
    );
  }

  public saveLaw(law: Law) {
    this.lawControllerService.saveLaw(law).subscribe(
      (data) => {
        this.responseSuccessful("Law saved!");
      },
      (error) => {
        if (error.error && error.error.errors) {
          this.showErrorMessage(error.error.errors[0].field + " " + error.error.errors[0].defaultMessage);
        } else {
          this.showErrorMessage(error);
        }
      },
    );
  }

  public download(item) {
    const downloadAction = this.serviceId ? this.serviceController.downloadServiceFile(this.serviceId, item.fileId) : this.serviceController.downloadFile(item.fileId);
    return downloadAction.subscribe((res) => {
      const pdfUrl = (window.URL || (window as any).webkitURL).createObjectURL(new Blob([res], { type: res.type }));
      const anchor = document.createElement("a");
      anchor.href = pdfUrl;
      anchor.setAttribute("download", item.fileId);
      anchor.click();
      // this.onChange.emit();
    });
  }

  public isActive(selectedItem, item) {
    return selectedItem && selectedItem.id === item.id;
  }

  public handleUpload(fileId: string, item) {
    // if previous exists then lets remove
    if (item.fileId) {
      this.serviceController.deleteFile(item.fileId).subscribe(
        (data2) => {
          item.fileId = undefined;
        },
      );
    }
    if (fileId) {
      this.saveFile(fileId, item);
    }
  }

  private saveFile(fileId: string, item) {
    setTimeout(() => {
      this.zone.run(() => {
        if (fileId) {
          item.fileId = fileId;
          if (item.fileId) {
            this.saveLaw(item);
          }
        }
      });
    });
  }

  public deleteFile(item) {
    const deleteAction = this.serviceId ? this.serviceController.deleteServiceFile(this.serviceId, item.fileId) : this.serviceController.deleteFile(item.fileId);
    deleteAction.subscribe(
      (data2) => {
        delete item.fileId;
        this.lawControllerService.saveLaw(item).subscribe(() => undefined);
      },
      (error) => this.showErrorMessageWithTitle("File delete error!", error),
    );
  }

  public searchTextChanged(value) {
    this.searchTextFilterObject.name = value;
  }

  public resetSearch() {
    this.searchValue = "";
    this.searchTextFilterObject.name = "";
  }

  public loadLaw(law: Law): void {
    if (law) {
      this.law = this.laws.find((it) => {
        return it.id === law.id;
      });
      this.showEdit = true;
    } else {
      this.law = new Law();
      this.law.name = this.searchTextFilterObject.name;
      this.law.shortName = (this.searchTextFilterObject && this.searchTextFilterObject.name) ? this.searchTextFilterObject.name.substring(0, 20) : "";
      this.showAdd = true;
    }
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getSystemLaws();
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }
}
